module.exports = __webpack_public_path__ + "assets/media/card-img-social-shares.d95d6d07.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/layouts/VideoInstallStep/assets/card-img-social-shares.jpg
// module id = 3251
// module chunks = 0